// extracted by mini-css-extract-plugin
export var otherContent = "video-player-module--other-content--629b1";
export var play = "video-player-module--play--a2af3";
export var playIcon = "video-player-module--play-icon--3c452";
export var player = "video-player-module--player--dad42";
export var playerWrapper = "video-player-module--playerWrapper--96973";